import { counts } from './_counts';
import { ability } from './ability';
import { api } from './api';
import { app } from './app';
import { audit } from './audit';
import { character } from './character';
import { common } from './common';
import { config } from './config';
import { decision } from './decision';
import { face } from './face';
import { inventory } from './inventory';
import { lib } from './lib';
import { more } from './more';
import { pet } from './pet';
import { property } from './property';
import { registry } from './registry';
import { review } from './review';
import { ui } from './ui';
import { user } from './user';

/**
 * Словарь интерфейса, собранный из пространств имён.
 *
 * Одно пространство — один модуль экранов, плюс `common` для слов, которые
 * повторяются везде. Разложено по файлам не ради красоты: пока словарь был
 * одним файлом, правки в него шли из каждой задачи и упирались друг в друга.
 *
 * Ключ именуется по СМЫСЛУ внутри своего пространства, а не по месту на
 * экране: `inventory.empty.published`, а не `inventory.textUnderTitle`.
 */
export const ru = {
  ...counts,
  common,
  ability,
  api,
  app,
  audit,
  registry,
  character,
  config,
  decision,
  face,
  inventory,
  lib,
  more,
  pet,
  property,
  review,
  ui,
  user,
};
